// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/$location._c.topics/route.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/$location._c.topics/route.tsx");
}
// REMIX HMR END

import { topicListExample } from '@commural/shared-resources/schemas/business/Topic.example';
import { useLoaderDataWithCache } from '@commural/shared-resources/utils/common';
import * as ToggleGroup from '@radix-ui/react-toggle-group';
import { Link, useSearchParams } from '@remix-run/react';
import { useCallback } from 'react';
import invariant from 'tiny-invariant';
import { z } from 'zod';
import { Pagination } from '~/components/Pagination';
import { ScrollView } from '~/components/ScrollView';
import { useFormattedDate } from '~/hooks/useFormattedDate';
import { getCapitalized } from '~/utils.server';
import { getPaginated } from '~/utils/getPaginated';
import cn from './Topics.module.css';
const TITLE = 'topics';
const PublishedFilterEnum = z.enum(['all', 'published', 'draft']);
export async function loader({
  request,
  context
}) {
  const title = await getCapitalized(TITLE, request, context);
  const url = new URL(request.url);
  const result = PublishedFilterEnum.safeParse(url.searchParams.get('published') ?? 'all');
  const publishedFilter = result.success ? result.data : 'all';
  const topicList = topicListExample.filter(el => {
    switch (publishedFilter) {
      case 'all':
        return true;
      case 'published':
        return !el.draft;
      case 'draft':
        return el.draft;
      default:
        return false;
    }
  });
  const {
    start,
    end,
    currentPage,
    pageCount
  } = getPaginated(url, topicList.length);
  return {
    title,
    topicList: topicList.slice(start, end),
    currentPage,
    pageCount,
    publishedFilter
  };
}
export const meta = ({
  data
}) => {
  invariant(data?.title, 'title is required');
  return [{
    title: data.title
  }];
};
export const handle = {
  title: TITLE
};
export default function Index() {
  _s();
  const {
    topicList,
    currentPage,
    pageCount,
    publishedFilter
  } = useLoaderDataWithCache();
  const {
    1: setSearchParams
  } = useSearchParams();
  const handleChangeFilter = useCallback(value => {
    setSearchParams({
      published: value
    }, {
      replace: true
    });
  }, [setSearchParams]);
  return <ScrollView>
      <section className={cn.Topics}>
        <header className={cn.Header}>
          <div>
            <ToggleGroup.Root className={cn.ToggleGroup} type="single" value={publishedFilter} onValueChange={handleChangeFilter}>

              <ToggleGroup.Item className={cn.ToggleGroupItem} value="all">
                all
              </ToggleGroup.Item>
              <ToggleGroup.Item className={cn.ToggleGroupItem} value="published">

                published
              </ToggleGroup.Item>
              <ToggleGroup.Item className={cn.ToggleGroupItem} value="draft">
                draft
              </ToggleGroup.Item>
            </ToggleGroup.Root>
          </div>
          <button className="debug-block">create topic</button>
        </header>
        <main>
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Published Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {topicList.map(el => <TopicListItem key={el.id} topic={el} />)}
            </tbody>
          </table>
        </main>
        <footer className={cn.Footer}>
          <Pagination currentPage={currentPage} pageCount={pageCount} additionalParams={{
          published: publishedFilter
        }} />

        </footer>
      </section>
    </ScrollView>;
}
_s(Index, "mdhUvvYSeqx0d5XMWkKXSuZcLD0=", false, function () {
  return [useLoaderDataWithCache, useSearchParams];
});
_c = Index;
function TopicListItem({
  topic
}) {
  _s2();
  const {
    id,
    title,
    draft
  } = topic;
  const publishedAt = useFormattedDate(topic.publishedAt);
  const status = draft ? 'draft' : 'published';
  return <tr>
      <td>
        <Link to={id}>{title}</Link>
      </td>
      <td>{publishedAt}</td>
      <td>{status}</td>
    </tr>;
}
_s2(TopicListItem, "zS5k+nE1DjGNeEp9vOQR+TYjtbU=", false, function () {
  return [useFormattedDate];
});
_c2 = TopicListItem;
var _c, _c2;
$RefreshReg$(_c, "Index");
$RefreshReg$(_c2, "TopicListItem");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;